/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.userAmazonCatalogue.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@ExperimentalJsExport
@JsExport
@Serializable
data class SearchRefinement(
    @SerialName("selectionType")
    val selectionType: String?,

    @SerialName("displayValue")
    val displayValue: String?,

    @SerialName("refinementValues")
    val refinementValues: List<SearchRefinementValue>?
)
